import React, { FC } from "react";
import "./styles.scss";
import AlliesList from "components/allies/alliesList/AlliesList";

import { ScalableImage, Typography } from "design_system/src";

interface Props {}

const AlliesSection: FC<Props> = () => (
  <section className="allies-section-container m_t_xxxl dso_container">
    <div className="title-container display_none_desktop">
      <Typography
        scale="heading3"
        weight="600"
        className="m_none"
        component="h2"
      >
        Nuestros aliados 🤝
      </Typography>
    </div>

    <AlliesList
      allies={[
        {
          name: "Bodega Aurrera",
          link: "https://www.bodegaaurrera.com.mx/",
          image: <ScalableImage
            desktopWidth={5}
            mobileWidth={5}
            className="img_cover"
            src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_aliado_bodega_aurrera"
            alt="Bodega Aurrera, aliado de Ozon para acceder a motos nuevas a crédito"
          />,
          logoOnly: true,
        },
        {
          name: "Uber",
          link: "https://uber-ozon.mobi/",
          image: <ScalableImage
            desktopWidth={5}
            mobileWidth={5}
            className="img_contain"
            src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_aliado_uber"
            alt="Aliado Uber – Conoce beneficios exclusivos para repartidores"
          />,
          logoOnly: true,
        },
        {
          name: "DiDi Food",
          link: "https://didi-ozon.mobi/",
          image: <ScalableImage
            desktopWidth={5}
            mobileWidth={5}
            style={{ height: "100%", width: "90%", objectFit: "cover" }}
            src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_aliado_DiDi"
            alt="Aliado Didi – Conoce beneficios exclusivos para repartidores"
          />,
          logoOnly: true,
        },
        {
          name: "Coppel",
          link: "https://www.coppel.com/",
          image: <ScalableImage
            desktopWidth={5}
            mobileWidth={5}
            style={{ height: "100%", width: "90%", objectFit: "contain" }}
            src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_aliado_coppel"
            alt="Coppel, aliado de Ozon para compra y financiamiento de motos"
          />,
          logoOnly: true,
        },
        {
          name: "Motul",
          link: "https://www.motul.com/es-MX/",
          image: <ScalableImage
            desktopWidth={5}
            mobileWidth={5}
            style={{ height: "30px", width: "100%", objectFit: "contain" }}
            src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_aliado_motul"
            alt="Motul, aliado de Ozon en lubricantes y productos para motocicletas"
          />,
          logoOnly: true,
        },
        {
          name: "Mundimotos",
          link: "https://www.mundimotos.com.mx/",
          image: <ScalableImage
            desktopWidth={5}
            mobileWidth={5}
            className="img_cover"
            src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_aliado_mundimotos"
            alt="Mundimotos, distribuidor de repuestos y llantas para motocicletas"
          />,
          logoOnly: true,
        },
      ]}
    />
  </section>
);

export default AlliesSection;
